module.exports = __webpack_public_path__ + "img/bg-product.aa7e2b24.jpg";